import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { Inbox } from './icons';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Usually a Button / ButtonLink */
  action?: ReactNode;
  /** Smaller padding for use inside cards and table bodies */
  compact?: boolean;
  className?: string;
}

export function EmptyState({ icon, title, description, action, compact, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'py-6 px-4' : 'py-12 px-6', className)}>
      <div className="mb-3 text-gray-300 dark:text-gray-600">{icon ?? <Inbox className="h-10 w-10" />}</div>
      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{title}</p>
      {description && <p className="mt-1 max-w-md text-sm text-gray-500 dark:text-gray-400">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
